<div class="card overflow-hidden" *ngIf="!initalData.isEdit" (click)="openInEditMode()">
  <div class="card-body p-0">
    <div class="table-responsive">
      <table mat-table [dataSource]="viewModeRowsData" class="fs-table table-countable">

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef class="fs-col-des">{{isAutomated ? 'Description' : ''}}</th>
          <td mat-cell *matCellDef="let row" class="fs-col-des" [attr.colspan]="row.rowId === 'textonly' ? 2 : ''">
            <!-- <span *ngIf="!(row.rowId === 'subheader')" class="ws-normal"
              [ngClass]="(row.rowId == 'crossCheck' ?  'misMatchValuesRed' : '')">{{ row.name ||
              '-' }}</span> -->
            @if(row.rowId === 'subheader'){

            } @else if(row.rowId === 'textonly'){
            <span class="ws-normal" [ngClass]="{'fw-semibold': row.styles?.includes('bold'),
              'text-italic overflow-visible': row.styles?.includes('italic'),
              'text-decoration-underline': row.styles?.includes('underline')
               }">{{ row.name || '' }}</span>
            } @else{
            <span class="fw-semibold" *ngIf="row.rowId === 'totalrow'">
              {{row.isDescHide ? '' : 'Total'}}
            </span>

            <p *ngIf="!(row.rowId === 'totalrow') && !((row.rowId === 'subtotal') && row.isDescHide)" class="ws-normal"
              [ngClass]="{'fw-semibold': row.styles?.includes('bold'),
              'text-italic overflow-visible': row.styles?.includes('italic'),
              'text-decoration-underline': row.styles?.includes('underline'),
            'px-3': row.rowId.includes('_subrow'),
          'misMatchValuesRed': row.rowId == 'crossCheck'  }">{{ row.name || '' }}</p>

            }
          </td>
        </ng-container>

        <ng-container matColumnDef="search">
          <th mat-header-cell *matHeaderCellDef class="fs-col-search"></th>
          <td mat-cell *matCellDef="let row" class="fs-col-search" [ngClass]="{'d-none':row.rowId === 'textonly' }">
            @if(row.rowId === 'subheader' || row.rowId === 'textonly' || row.rowId === 'subtotal'){

            } @else{
            <ng-container *ngIf="row.rowId !== 'addrow' && row.rowId !== 'totalrow' && row.rowId !== 'crossCheck'">
              <mat-form-field floatLabel="always" class="fixed-label label-none w-100 icon-form-before"
                style="min-width: 120px;">
                <mat-label>Search</mat-label>
                <input matInput type="text" placeholder="Search" maxlength="50" [ngModel]="search" disabled />
                <span matPrefix>
                  <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                </span>
              </mat-form-field>
            </ng-container>
            }

          </td>
        </ng-container>

          <ng-container [matColumnDef]="column.colId" *ngFor="let column of columnsData;let columnIndex = index;">
          <th mat-header-cell *matHeaderCellDef class="fs-col-newadded text-end p-2 overflow-visible"
            [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic') }">
            <span class="flexbox-row gap-0 justify-content-end">
              <span class="flexbox-column gap-0">
                <pre class="overflow-visible"
                  [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic') }">{{column.name}}</pre>
                <ng-container *ngIf="column.extName">
                  <pre class="overflow-visible"
                    [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic') }">{{column.extName}}</pre>
                </ng-container>
                <ng-container *ngIf="column.formatValue">
                  <pre class="overflow-visible"
                    [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic') }">{{column.formatValue}}</pre>
                </ng-container>

              </span>
            </span>

          </th>
          <td mat-cell *matCellDef="let row" class="fs-col-newadded text-end pe-2"
            [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic overflow-visible': column?.styles?.includes('italic') }">
            @if(row.rowId === 'subheader'){
            <span class="flexbox-row gap-8 justify-content-end">
              <span class="flexbox-column gap-0">
                <pre
                  [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.values[columnIndex]?.styles?.includes('bold')),
            'text-italic overflow-visible': column?.styles?.includes('italic') }">{{ row.values[columnIndex]?.extName ? row.values[columnIndex].extName : row.name  }}</pre>
              </span>
            </span>

            } @else if(row.rowId === 'textonly'){

            } @else{
            <ng-container *ngIf="!isInsideWorkbook">
              <mat-form-field [title]="showFormattedNumber(getColValue(row.values, column.colId))"
                class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                <input matInput type="text" class="cell-right full-row"
                  [value]="showFormattedNumber(getColValue(row.values, column.colId))" disabled />
              </mat-form-field>
              <!-- {{ showFormattedNumber(getColValue(row.values, column.colId)) || '-'}} -->
            </ng-container>

            <ng-container *ngIf="isInsideWorkbook">
              <span *ngIf="row.rowId !== 'totalrow' && row.rowId !== 'crossCheck' && column.colId !== 'total'">
                <mat-form-field [title]="showFormattedNumber(getColValue(row.values, column.colId))"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row"
                    [value]="showFormattedNumber(getColValue(row.values, column.colId))" disabled />
                </mat-form-field>
                <!-- {{ showFormattedNumber(getColValue(row.values, column.colId)) }} -->
              </span>
              <span *ngIf="row.rowId !== 'totalrow' && row.rowId !== 'crossCheck' && column.colId === 'total'">
                <mat-form-field [title]="showFormattedNumber(getRowTotalValue(row.values))"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row"
                    [value]="showFormattedNumber(getRowTotalValue(row.values))" disabled />
                </mat-form-field>
                <!-- {{ showFormattedNumber(getRowTotalValue(row.values)) }} -->
              </span>
              <span *ngIf="row.rowId === 'totalrow' && row.rowId !== 'crossCheck' && column.colId !== 'total'">
                <mat-form-field [title]="showFormattedNumber(getTotalColValue(column.colId))"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row"
                    [value]="showFormattedNumber(getTotalColValue(column.colId))" disabled />
                </mat-form-field>
                <!-- {{ showFormattedNumber(getTotalColValue(column.colId)) }} -->
              </span>
              <span *ngIf="row.rowId === 'totalrow' && row.rowId !== 'crossCheck' && column.colId === 'total'">
                <mat-form-field [title]="showFormattedNumber(getGrandTotalValue())"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row"
                    [value]="showFormattedNumber(getGrandTotalValue())" disabled />
                </mat-form-field>
                <!-- {{ showFormattedNumber(getGrandTotalValue()) }} -->
              </span>
              <span *ngIf="row.rowId ==='crossCheck' && column.colId === 'currYear'">
                <mat-form-field [title]="showFormattedNumber(getCrossCheckVal('currYear'))"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row misMatchValuesRed"
                    [value]="showFormattedNumber(getCrossCheckVal('currYear'))" disabled />
                </mat-form-field>
                <!-- {{showFormattedNumber(getCrossCheckVal('currYear'))}} -->
              </span>
              <span *ngIf="row.rowId ==='crossCheck' && column.colId === 'priorYear'">
                <mat-form-field [title]="showFormattedNumber(getCrossCheckVal('priorYear'))"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row misMatchValuesRed"
                    [value]="showFormattedNumber(getCrossCheckVal('priorYear'))" disabled />
                </mat-form-field>
                <!-- {{showFormattedNumber(getCrossCheckVal('priorYear'))}} -->
              </span>

            </ng-container>
            }

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="viewModeDispCol" [ngClass]="{'d-none': initalData.isHeaderHidden }"></tr>
        <tr mat-row *matRowDef="let row; columns: viewModeDispCol" (click)="openInEditMode()"
          [class.hidden]="isNoDifference(row)" [ngClass]="{'d-none': row.isHide,
          'subHeaderBgCss': (row.rowId === 'subheader'),
          'text-italic overflow-visible': row.styles?.includes('italic'),
          'text-decoration-underline': row.styles?.includes('underline')
        }">
        </tr>
      </table>
    </div>
  </div>
</div>

<div *ngIf="!isAutomated && initalData.isEdit" class="card overflow-hidden">
  <div class="card-body p-0 gap-20">
    <div class="flexbox-row align-items-center justify-content-between px-2 pt-3">
      <div class="button-group gap-8 flex-1">
        <ng-container *ngFor="let item of formatList; let i = index">
          <button [ngClass]="{'active': item.active }" (click)="onChangeFormatStyles(i)"
            [disabled]="activeFormatList.length ? !(activeFormatList.includes(item.value)) : true" mat-button
            mat-stroked-button color="dark" class="button-small-icon" [title]="item.title">
            <i [ngClass]="item.iconClass"></i>
          </button>
        </ng-container>
        <button [disabled]="!activeFormatList.length" mat-button mat-flat-button color="primary" class="button-medium"
          (click)="applyStylesOnSelectedColumn(true)">
          Apply
        </button>
        <button [disabled]="!activeFormatList.length" mat-button mat-stroked-button color="dark" class="button-medium"
          (click)="applyStylesOnSelectedColumn(false)">
          Cancel
        </button>
      </div>
      <div class="button-group justify-content-end gap-8">
        <button mat-button mat-stroked-button color="dark" class="button-medium" [matMenuTriggerFor]="columnMenu"
          #addManualColMenu="matMenuTrigger" [disabled]="colCounter >= 5 || (activeFormatList.length ? true : false)">
          <span class="flexbox-row gap-8">
            <i class="fa-solid fa-plus"></i>
            <span button-label>Add Column</span>
            <i class="fa-regular fa-angle-down"></i>
          </span>
        </button>
        <button mat-button mat-stroked-button color="dark" class="button-medium-icon" title="Delete"
          (click)="deleteTable()" [disabled]="(activeFormatList.length ? true : false)">
          <i class="fa-regular fa-trash-can"></i>
        </button>

        <mat-menu #columnMenu="matMenu" xPosition="before">
          @for (column of columnOptions(); track $index) {
          <button mat-menu-item (click)="column?.subMenu?.length ? '' : addColumn(column)"
            [disabled]="isColDisabled(column.key)" [matMenuTriggerFor]="column?.subMenu?.length ? colSubMenu : null">
            <span>{{ column?.value }}</span>
          </button>
          <mat-menu #colSubMenu="matMenu">
            @for (subCol of column?.subMenu; track $index; let index = $index) {
            <button mat-menu-item class="add-row-btn" (click)="addMultiColumns(index+1);addManualColMenu?.closeMenu()"
              [disabled]="subCol?.isDisabled">
              <div class="flexbox-row gap-8 justify-content-between">
                <span class="button-label">{{ subCol?.value }}</span>
              </div>
            </button>
            }
          </mat-menu>
          }

        </mat-menu>
      </div>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="fs-table table-countable hover-action border-rounded-bottom"
        cdkDropList (cdkDropListDropped)="drop($event)" cdkDropListData="dataSource">

        <ng-container matColumnDef="hide">
          <th mat-header-cell *matHeaderCellDef table-with-title class="fs-col-drag ps-2">
            <div class="table-button-group">
              <button mat-button class="button-text show-always"
                [ngClass]="{'hover-action-item': !initalData.isHeaderHidden}"
                (click)="hideColumnHeaderAndSubHeader('header',null)"
                title="{{!initalData.isHeaderHidden ? 'Hide header' : 'Unhide header'}}">
                <i class="fa-regular fs-3" [ngClass]="(initalData.isHeaderHidden ? 'fa-eye-slash' : 'fa-eye')"></i>
              </button>
              <button mat-button class="hover-action-item kebab-button" [matMenuTriggerFor]="headerActions"
                (click)="$event.stopPropagation();">
                <i class="fas fa-ellipsis-vertical"></i>
              </button>
              <mat-menu #headerActions="matMenu" xPosition="before" class="side-menu">
                <button mat-menu-item class="add-row-btn"
                  (click)="formatHeaderAndSubHeader('header','border-bottom',null)">
                  <span>Format</span>
                </button>
              </mat-menu>
            </div>

          </th>
          <td mat-cell *matCellDef="let row;let i = index" class="fs-col-drag ps-2"
            [ngClass]="{'disabled': activeFormatList.length ? true : false}">
            <div class="table-button-group">
              <button mat-button (click)="hideRow($event, row, i)" class="button-text"
                [ngClass]="{'hover-action-item': !row.isHide}"
                *ngIf="(row.rowId === 'totalrow' || row.rowId === 'subheader')"
                title="{{!row.isHide ? 'Hide' : 'Unhide'}}">
                <i class="fa-regular fs-3" [ngClass]="(row.isHide ? 'fa-eye-slash' : 'fa-eye')"></i>
              </button>
              <button mat-button class="button-text hover-action-item dragable-icon"
                *ngIf="row.rowId !== 'totalrow' && row.rowId !== 'addrow' && row.rowId !== 'subheader'">
                <i class="fa-solid fa-grip-dots-vertical"></i>
              </button>

              <mat-checkbox class="button-text" [ngClass]="{'hover-action-item': !row.isChecked}"
                *ngIf="row.rowId !== 'totalrow' && row.rowId !== 'addrow' && row.rowId !== 'subheader'"
                (click)="$event.stopPropagation();" [checked]="row.isChecked"
                (change)="onChangeSelection($event.checked, i);">
              </mat-checkbox>

              <button mat-button class="hover-action-item kebab-button" [matMenuTriggerFor]="rowActions"
                *ngIf="row.rowId !== 'addrow'" (click)="$event.stopPropagation();">
                <i class="fas fa-ellipsis-vertical"></i>
              </button>
              <mat-menu #rowActions="matMenu" xPosition="before" class="side-menu">
                <ng-container *ngFor="let action of rowActionsData">
                  <button [disabled]="action.disable"
                    *ngIf="(action?.allowedRows && ((row.rowId === 'addrow') || (row.rowId === 'totalrow') || (row.rowId === 'subheader') ||
                     (row.rowId === 'general') || (row.rowId === 'textonly') || (row.rowId === 'subtotal')) ? action.allowedRows.includes(row.rowId) : action.default)"
                    mat-menu-item class="add-row-btn" (click)="applyRowAction(row,action.key,i)">
                    <span *ngIf="action.key === 'hide'">{{ (row.rowId === 'subtotal')
                      ?
                      (row.isDescHide ? 'Show Subtotal Desc' : 'Hide Subtotal Desc') :
                      (row.isDescHide ? 'Show Total Desc' : 'Hide Total Desc')}}</span>
                    <span *ngIf="action.key !== 'hide'">{{ action.value }}</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>

          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef table-with-title class="fs-col-des">{{isAutomated ? 'Description' : ''}}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" class="fs-col-des"
            [ngClass]="{'disabled': activeFormatList.length ? true : false}"
            [attr.colspan]="row.rowId === 'textonly' ? 2 : ''">
            @if(row.rowId === 'subheader'){

            } @else if(row.rowId === 'textonly'){
            <mat-form-field class="fixed-label label-none w-100 icon-form-after action-2" [ngClass]="{'fw-semibold': row.styles?.includes('bold'),
            'text-italic overflow-visible': row.styles?.includes('italic'),
            'text-decoration-underline': row.styles?.includes('underline') }" floatLabel="always">
              <mat-label>Enter Text Here</mat-label>
              <textarea matInput [id]="row.rowId+'_'+i" [(ngModel)]="row.name" placeholder="Enter Text Here"></textarea>
            </mat-form-field>
            } @else{
            <ng-container *ngIf="row.rowId === 'addrow'">
              <button mat-button mat-stroked-button color="dark" class="button-medium" [matMenuTriggerFor]="rowMenu">
                <span class="flexbox-row gap-8">
                  <i class="fa-solid fa-plus"></i>
                  <span button-label>Add Row</span>
                  <i class="fa-regular fa-angle-down"></i>
                </span>
              </button>
              <mat-menu class="addrow-menu-items" #rowMenu="matMenu" xPosition="before">
                <ng-container *ngFor="let action of rowOptions">
                  <button mat-menu-item class="add-row-btn" [disabled]="action.disabled"
                    [matMenuTriggerFor]="action.subMenu.length ? rowSubMenu : null"
                    (click)="action.subMenu.length ? '' : addRowAction(row,action)">
                    <div class="flexbox-row gap-8 justify-content-between">
                      <span class="button-label">{{action.value}}</span>
                    </div>
                  </button>
                  <mat-menu #rowSubMenu="matMenu">
                    <ng-container *ngFor="let subItem of action.subMenu">
                      <button mat-menu-item class="add-row-btn" (click)="addRowAction(row,action,subItem)">
                        <div class="flexbox-row gap-8 justify-content-between">
                          <span class="button-label">{{subItem.value}}</span>
                        </div>
                      </button>
                    </ng-container>
                  </mat-menu>
                </ng-container>
              </mat-menu>
            </ng-container>

            <span class="fw-semibold" *ngIf="row.rowId === 'totalrow'">
              {{row.isDescHide ? '' : 'Total'}}
            </span>

            <ng-container *ngIf="row.rowId !== 'addrow' && row.rowId !== 'totalrow'">
              <!-- <ng-container *ngIf="editRowId !== row.rowId">
                <span class="text-ellipse" title="{{ row.name }}" *ngIf="row.name">{{ row.name }}</span>
                <span class="text-ellipse" title="Description here" *ngIf="!row.name">Description here</span>
              </ng-container> -->

              <!-- Row Desc Edit case in templates -->
              <ng-container *ngIf="!isInsideWorkbook">
                <mat-form-field *ngIf="!((row.rowId === 'subtotal') && row.isDescHide)"
                  class="fixed-label label-none w-100 icon-form-after action-2" [ngClass]="{'fw-semibold': row.styles?.includes('bold'),
                'text-italic overflow-visible': row.styles?.includes('italic'),
                'text-decoration-underline': row.styles?.includes('underline'),
              'px-3': row.rowId.includes('_subrow') }" floatLabel="always">
                  <mat-label>Description</mat-label>
                  <input matInput type="text" placeholder="Description here" [(ngModel)]="row.name">
                  <!-- <div matSuffix class="actions">
                    <button mat-button color="success" (click)="changeRowDesc(row)">
                      <i class="fa-regular fa-check"></i>
                    </button>
                    <button mat-button color="cancel" (click)="cancelRowDescChange(row)">
                      <i class="fa-regular fa-xmark clear-icon"></i>
                    </button>
                  </div> -->
                </mat-form-field>
              </ng-container>

              <!-- Entire row edit case in workbook -->
              <ng-container *ngIf="isInsideWorkbook">
                <mat-form-field *ngIf="!((row.rowId === 'subtotal') && row.isDescHide)"
                  class="fixed-label label-none w-100" floatLabel="always" [ngClass]="{'fw-semibold': row.styles?.includes('bold'),
                'text-italic overflow-visible': row.styles?.includes('italic'),
                'text-decoration-underline': row.styles?.includes('underline'),
                'px-3': row.rowId.includes('_subrow') }">
                  <mat-label>Description</mat-label>
                  <input [id]="row.rowId+'NFS'" (keydown.Tab)="onTabChange($event,i)" matInput type="text"
                    placeholder="Description here" [(ngModel)]="row.name" />
                </mat-form-field>
              </ng-container>

            </ng-container>
            }

          </td>
        </ng-container>

        <ng-container matColumnDef="search">
          <th mat-header-cell *matHeaderCellDef class="fs-col-search"></th>
          <td mat-cell *matCellDef="let row" class="fs-col-search"
            [ngClass]="{'disabled': activeFormatList.length ? true : false, 'd-none':row.rowId === 'textonly' }">
            @if(row.rowId === 'subheader' ||row.rowId === 'subtotal'){

            } @else{
            <ng-container *ngIf="row.rowId !== 'addrow' && row.rowId !== 'totalrow'">
              <!-- <mat-form-field class="fixed-label label-none w-100 icon-form-before">
                  <mat-label>Search</mat-label>
                  <input matInput type="text" class="color-grey" placeholder="Search" maxlength="50" [ngModel]="search"
                    [disabled]="isInsideWorkbook && (columnIdsOnly.includes('currYear') || columnIdsOnly.includes('priorYear'))  ? false : true"
                    [matMenuTriggerFor]="trialBalMenu" readonly />
                  <span matPrefix>
                <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                  </span>
                </mat-form-field> -->
              <button mat-button mat-stroked-button color="dark" class="button-medium text-start w-100"
                [matMenuTriggerFor]="trialBalMenu"
                [disabled]="isInsideWorkbook && (columnIdsOnly.includes('currYear') || columnIdsOnly.includes('priorYear'))  ? false : true">
                <span class="flexbox-row gap-8">
                  <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                  <span class="button-label">Search</span>
                </span>
              </button>
              <mat-menu #trialBalMenu="matMenu" class="trial-menu">
                <div class="flex-table fixed-header w-100" *ngIf="trialBalanceData.length > 0"
                  style="max-height: 400px; overflow-y: auto;">
                  <div class="flex-table-header">
                    <p class="ft-cell ps-2 text-left des-cell">Description</p>
                    <p class="ft-cell text-end current-date-cell">{{currentDate}}</p>
                    <p class="ft-cell pe-2 text-end prev-date-cell">{{previousDate}}</p>
                  </div>
                  <button mat-menu-item class="ft-row button-row" *ngFor="let trial of trialBalanceData"
                    (click)="setTrialIdToRow(trial, row)">
                    <p class="ft-cell ps-2 text-left des-cell" title="{{ trial.description }}">
                      <span class="text-ellipse">{{ trial.description }}</span>
                    </p>
                    <p class="ft-cell text-end current-date-cell">{{ showFormattedNumber(trial.currYearValue) }}</p>
                    <p class="ft-cell pe-2 text-end prev-date-cell">{{ showFormattedNumber(trial.prevYearValue) }}</p>
                  </button>
                </div>
                <div style="min-height:400px" *ngIf="trialBalanceData.length === 0">
                  <ng-template #noDataFound>
                    <div class="no-data-found">
                      <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                      <h6>No records found!</h6>
                    </div>
                  </ng-template>
                </div>
              </mat-menu>
            </ng-container>
            }

          </td>
        </ng-container>

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <div class="align-items-end justify-content-end d-flex flex-row flex-nowrap gap-24">
              <button mat-button class="button-text" *ngIf="!columnsData.length" [disabled]="true">
                Add Column
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'disabled': activeFormatList.length ? true : false}">
          </td>
        </ng-container>

        <ng-container [matColumnDef]="column.colId"
          *ngFor="let column of columnsData;let columnIndex = index;trackBy : trackByColumn">
          <th mat-header-cell *matHeaderCellDef class="fs-col-newadded text-end p-2" [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic overflow-visible': column?.styles?.includes('italic'),
            'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false }">
            <ng-container *ngIf=" editColumnId !== column?.colId ">
              <span class="flexbox-row gap-0 justify-content-end">
                <span class="flexbox-column gap-0">
                  <pre class="overflow-visible"
                    [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic'),
                  'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false }">{{ column.name }}</pre>
                  <ng-container *ngIf="column.extName">
                    <pre class="overflow-visible"
                      [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic'),
                  'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false }">{{ column.extName }}</pre>
                  </ng-container>
                  <ng-container *ngIf="column.formatValue">
                    <pre class="overflow-visible"
                      [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic') }">{{column.formatValue}}</pre>
                  </ng-container>
                </span>
                <button mat-button class="kebab-button" [matMenuTriggerFor]="colActions"
                  (menuOpened)="columnActionsMenu('OPEN')" (menuClosed)="columnActionsMenu('CLOSED')"
                  #addColumnMenu="matMenuTrigger">
                  <i class="fas fa-ellipsis-vertical"></i>
                </button>
                <mat-menu #colActions="matMenu" xPosition="before">
                  <ng-container *ngFor="let action of columnActions">
                    <button mat-menu-item class="add-row-btn"
                      *ngIf="action.key === 'mmyyformat' ? (column.colId === 'priorYear' || column.colId === 'currYear') :
                     ((action.key === 'rename') ? !(column.colId === 'priorYear' || column.colId === 'currYear') : true)"
                      [matMenuTriggerFor]="action.subMenu.length ? subMenu : null"
                      (click)="action.subMenu.length ? '' : this.executeColumnActions($event,column,action.key)">
                      <div class="flexbox-row gap-8 justify-content-between">
                        <span class="button-label">{{ action.value }}</span>
                      </div>
                    </button>
                    <mat-menu #subMenu="matMenu">
                      <ng-container *ngFor="let subItem of action.subMenu">
                        <button mat-menu-item class="add-row-btn" [disabled]="column.format === subItem.key"
                          (click)="applyColAction(column,action.key ,subItem)">
                          <div class="flexbox-row gap-8 justify-content-between">
                            <span class="button-label">{{ subItem.name }}</span>
                          </div>
                        </button>
                      </ng-container>
                    </mat-menu>
                  </ng-container>
                </mat-menu>
              </span>
            </ng-container>

          </th>
          <td mat-cell *matCellDef="let row;let rowIndex = index" class="fs-col-newadded text-end pe-2" [ngClass]="{'disabled': (activeFormatList.length ? !(activeFormatList.includes(column.colId)) : false),
          'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false ,
          'fw-semibold': column?.styles?.includes('bold'),
          'text-italic overflow-visible': column?.styles?.includes('italic') }">
            @if(row.rowId === 'subheader'){
            <span class="flexbox-row gap-0 justify-content-end">
              <span class="flexbox-column gap-0">
                <pre
                  [ngClass]="{'disabled': (activeFormatList.length ? !(activeFormatList.includes(column.colId)) : false),
                'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false ,
                'fw-semibold': (column?.styles?.includes('bold') || row.values[columnIndex]?.styles?.includes('bold')),
                'text-italic overflow-visible': column?.styles?.includes('italic') }">{{ row.values[columnIndex]?.extName ? row.values[columnIndex].extName : row.name  }}</pre>
              </span>

              <button mat-button class="kebab-button" [matMenuTriggerFor]="subcolActions"
                (menuOpened)="columnActionsMenu('OPEN')" (menuClosed)="columnActionsMenu('CLOSED')"
                #addColumnMenu="matMenuTrigger">
                <i class="fas fa-ellipsis-vertical"></i>
              </button>
              <mat-menu #subcolActions="matMenu" xPosition="before">
                <ng-container *ngFor="let action of columnActions">
                  <button mat-menu-item class="add-row-btn" *ngIf="action.key === 'rename' || action.key === 'delete'"
                    (click)="this.subHeaderColActions($event,row,rowIndex, columnIndex ,action.key)">
                    <div class="flexbox-row gap-8 justify-content-between">
                      <span class="button-label">{{ action.value }}</span>
                    </div>
                  </button>
                </ng-container>
              </mat-menu>
            </span>

            } @else if(row.rowId === 'textonly'){

            } @else{
            <ng-container *ngIf="!isInsideWorkbook">
              <mat-form-field *ngIf=" row?.rowId !== 'addrow' " class="fixed-label label-none flex-1 edit-mode"
                [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                <input matInput type="text" class="cell-right full-row" value="0" disabled placeholder="0" />
              </mat-form-field>
              <span *ngIf=" row?.rowId === 'addrow' "></span>
            </ng-container>

            <ng-container *ngIf="isInsideWorkbook">
              <ng-container *ngIf="row.rowId === 'subtotal';else generalRows ">
                <mat-form-field class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input *ngIf="!(column.colId === 'total')" [id]="row.rowId+'NFS'+column.colId" matInput type="text"
                    class="cell-right full-row" [value]="showFormattedNumber(getColValue(row.values, column.colId))"
                    placeholder="0" disabled />
                  <input *ngIf="column.colId === 'total'" [id]="row.rowId+'NFS'+column.colId" matInput type="text"
                    class="cell-right full-row" [value]="showFormattedNumber(getRowTotalValue(row.values))"
                    placeholder="0" disabled />
                </mat-form-field>
              </ng-container>
              <ng-template #generalRows>
                <ng-container *ngIf="row.rowId !=='addrow' && row.rowId !== 'totalrow' && column.colId !== 'total'">
                  <mat-form-field class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                    <input [id]="row.rowId+'NFS'+column.colId" matInput
                      [type]="row.trialBalanceId > 0 ? 'text' : 'number'" class="cell-right full-row" [value]="row.trialBalanceId > 0 ? (showFormattedNumber(getColValue(row.values, column.colId)) == 0 ? '' : showFormattedNumber(getColValue(row.values, column.colId))) :
                      (getColValue(row.values, column.colId) == 0 ? '' : getColValue(row.values, column.colId)) "
                      placeholder="0" onKeyPress="if(this.value.length == 14) return false;"
                      (keydown.Tab)="onTabChange($event,rowIndex,columnIndex)"
                      (blur)="setColvalue(row.values, column.colId,row.rowId+'NFS'+column.colId)"
                      [disabled]="row.trialBalanceId > 0 || row.rowId === 'subtotal'" />
                  </mat-form-field>
                  <!-- <div *ngIf="editRowId !== row.rowId">
                    {{ showFormattedNumber(getColValue(row.values, column.colId)) }}
                  </div> -->
                </ng-container>
                <mat-form-field [title]="showFormattedNumber(getRowTotalValue(row.values))"
                  *ngIf="row.rowId !=='addrow' && row.rowId !== 'totalrow' && column.colId === 'total'"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row" placeholder="0"
                    [value]="showFormattedNumber(getRowTotalValue(row.values))" disabled />
                </mat-form-field>


                <span *ngIf="row.rowId ==='addrow'"></span>
                <mat-form-field [title]="showFormattedNumber(getTotalColValue(column.colId))"
                  *ngIf="row.rowId === 'totalrow' && column.colId !== 'total'"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row" placeholder="0"
                    [value]="showFormattedNumber(getTotalColValue(column.colId))" disabled />
                </mat-form-field>

                <mat-form-field [title]=" showFormattedNumber(getGrandTotalValue())"
                  *ngIf="row.rowId === 'totalrow' && column.colId === 'total'"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row" placeholder="0"
                    [value]=" showFormattedNumber(getGrandTotalValue())" disabled />
                </mat-form-field>
              </ng-template>


            </ng-container>
            }


          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"
          [ngClass]="{'bg-primary-lighter': activeFormatList.includes('header'),'disabled': activeFormatList.length ? true : false }">
        </tr>
        <tr mat-row *matRowDef="let row;let rowIndex=index; columns: displayedColumns" cdkDrag [cdkDragData]="row"
          [cdkDragDisabled]="(row.rowId === 'totalrow' || row.rowId === 'addrow' || row.rowId === 'subheader')"
          (click)="editRow(row)" [ngClass]="{
          'subHeaderBgCss': ((row.rowId === 'subheader') && !(rowIndex === activeRowIndex)),
          'bg-primary-lighter': rowIndex === activeRowIndex,
          'text-italic overflow-visible': row.styles?.includes('italic'),
          'text-decoration-underline': row.styles?.includes('underline')
        }">
        </tr>
      </table>
    </div>
  </div>
</div>

<!-- Below block used for automated PPE notes -->
<div *ngIf="isAutomated && initalData.isEdit" class="card overflow-hidden">
  <div class="card-body p-0 gap-20">
    <div class="flexbox-row align-items-center justify-content-between px-2 pt-3">
      <div class="button-group gap-8 flex-1">
        <ng-container *ngFor="let item of formatList; let i = index">
          <button [ngClass]="{'active': item.active }" (click)="onChangeFormatStyles(i)"
            [disabled]="activeFormatList.length ? !(activeFormatList.includes(item.value)) : true" mat-button
            class="button-small-icon" [title]="item.title">
            <i [ngClass]="item.iconClass"></i>
            <!-- <img alt="" [src]="item.path" /> -->
          </button>
        </ng-container>
        <button [disabled]="!activeFormatList.length" mat-button mat-flat-button color="primary" class="button-medium"
          (click)="applyStylesOnSelectedColumn(true)">
          Apply
        </button>
        <button [disabled]="!activeFormatList.length" mat-button mat-stroked-button color="dark" class="button-medium"
          (click)="applyStylesOnSelectedColumn(false)">
          Cancel
        </button>
      </div>
      <div class="button-group justify-content-end gap-8">
        <button mat-button mat-stroked-button color="dark" class="button-medium-icon" title="Delete"
          (click)="deleteTable()" [disabled]="(activeFormatList.length ? true : false)">
          <i class="fa-regular fa-trash-can"></i>
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="fs-table table-countable hover-action border-rounded-bottom"
        cdkDropList (cdkDropListDropped)="drop($event)" cdkDropListData="dataSource">

        <ng-container matColumnDef="hide">
          <th mat-header-cell *matHeaderCellDef table-with-title class="fs-col-drag ps-2">
            <div class="table-button-group">
              <button mat-button class="button-text show-always"
                [ngClass]="{'hover-action-item': !initalData.isHeaderHidden}"
                (click)="hideColumnHeaderAndSubHeader('header',null)"
                title="{{!initalData.isHeaderHidden ? 'Hide header' : 'Unhide header'}}">
                <i class="fa-regular fs-3" [ngClass]="(initalData.isHeaderHidden ? 'fa-eye-slash' : 'fa-eye')"></i>
              </button>
              <button mat-button class="hover-action-item kebab-button" [matMenuTriggerFor]="headerActions"
                (click)="$event.stopPropagation();">
                <i class="fas fa-ellipsis-vertical"></i>
              </button>
              <mat-menu #headerActions="matMenu" xPosition="before" class="side-menu">
                <button mat-menu-item class="add-row-btn"
                  (click)="formatHeaderAndSubHeader('header','border-bottom',null)">
                  <span>Format</span>
                </button>
              </mat-menu>
            </div>

          </th>
          <td mat-cell *matCellDef="let row;let i = index" class="fs-col-drag ps-2"
            [ngClass]="{'disabled': activeFormatList.length ? true : false}">
            <div class="table-button-group" *ngIf="!(row.rowId === 'crossCheck')">
              <button mat-button (click)="hideRow($event, row, i)" class="button-text"
                [ngClass]="{'hover-action-item': !row.isHide}"
                *ngIf="(row.rowId === 'totalrow' || row.rowId === 'subheader')"
                title="{{!row.isHide ? 'Hide' : 'Unhide'}}">
                <i class="fa-regular fs-3" [ngClass]="(row.isHide ? 'fa-eye-slash' : 'fa-eye')"></i>
              </button>
              <button mat-button class="button-text hover-action-item dragable-icon"
                *ngIf="row.rowId !== 'totalrow' && row.rowId !== 'addrow' && row.rowId !== 'subheader'">
                <i class="fa-solid fa-grip-dots-vertical"></i>
              </button>

              <mat-checkbox class="button-text" [ngClass]="{'hover-action-item': !row.isChecked}"
                *ngIf="row.rowId !== 'totalrow' && row.rowId !== 'addrow' && row.rowId !== 'subheader'"
                (click)="$event.stopPropagation();" [checked]="row.isChecked"
                (change)="onChangeSelection($event.checked, i);">
              </mat-checkbox>

              <button mat-button class="hover-action-item kebab-button" [matMenuTriggerFor]="rowActions"
                *ngIf="row.rowId !== 'addrow'" (click)="$event.stopPropagation();">
                <i class="fas fa-ellipsis-vertical"></i>
              </button>
              <mat-menu #rowActions="matMenu" xPosition="before" class="side-menu">
                <ng-container *ngFor="let action of rowActionsData">
                  <button [disabled]="action.disable"
                    *ngIf="(action?.allowedRows && ((row.rowId === 'addrow') || (row.rowId === 'totalrow') || (row.rowId === 'subheader') ||
                   (row.rowId === 'general') || (row.rowId === 'textonly') || (row.rowId === 'subtotal')) ? action.allowedRows.includes(row.rowId) : action.default)"
                    mat-menu-item class="add-row-btn" (click)="applyRowAction(row,action.key,i)">
                    <span *ngIf="action.key === 'hide'">{{ (row.rowId === 'subtotal')
                      ?
                      (row.isDescHide ? 'Show Subtotal Desc' : 'Hide Subtotal Desc') :
                      (row.isDescHide ? 'Show Total Desc' : 'Hide Total Desc')}}</span>
                    <span *ngIf="action.key !== 'hide'">{{ action.value }}</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>

          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef table-with-title class="fs-col-des">Description</th>
          <td mat-cell *matCellDef="let row; let i = index" class="fs-col-des"
            [ngClass]="{'disabled': activeFormatList.length ? true : false}"
            [attr.colspan]="row.rowId === 'textonly' ? 2 : ''">
            @if(row.rowId === 'subheader'){

            } @else if(row.rowId === 'textonly'){
            <mat-form-field class="fixed-label label-none w-100 icon-form-after action-2" [ngClass]="{'fw-semibold': row.styles?.includes('bold'),
            'text-italic overflow-visible': row.styles?.includes('italic'),
            'text-decoration-underline': row.styles?.includes('underline') }" floatLabel="always">
              <mat-label>Enter Text Here</mat-label>
              <textarea matInput [id]="row.rowId+'_'+i" [(ngModel)]="row.name" placeholder="Enter Text Here"></textarea>
            </mat-form-field>
            } @else{
            <ng-container *ngIf="row.rowId === 'addrow'">
              <button mat-button mat-stroked-button color="dark" class="button-medium" [matMenuTriggerFor]="rowMenu">
                <span class="flexbox-row gap-8">
                  <i class="fa-solid fa-plus"></i>
                  <span button-label>Add Row</span>
                  <i class="fa-regular fa-angle-down"></i>
                </span>
              </button>
              <mat-menu class="addrow-menu-items" #rowMenu="matMenu" xPosition="before">
                <ng-container *ngFor="let action of rowOptions">
                  <button mat-menu-item class="add-row-btn" [disabled]="action.disabled"
                    [matMenuTriggerFor]="action.subMenu.length ? rowSubMenu : null"
                    (click)="action.subMenu.length ? '' : addRowAction(row,action)">
                    <div class="flexbox-row gap-8 justify-content-between">
                      <span class="button-label">{{action.value}}</span>
                    </div>
                  </button>
                  <mat-menu #rowSubMenu="matMenu">
                    <ng-container *ngFor="let subItem of action.subMenu">
                      <button mat-menu-item class="add-row-btn" (click)="addRowAction(row,action,subItem)">
                        <div class="flexbox-row gap-8 justify-content-between">
                          <span class="button-label">{{subItem.value}}</span>
                        </div>
                      </button>
                    </ng-container>
                  </mat-menu>
                </ng-container>
              </mat-menu>
            </ng-container>

            <span class="fw-semibold" *ngIf="row.rowId === 'totalrow'">
              {{row.isDescHide ? '' : 'Total'}}
            </span>
            <span class="fw-semibold misMatchValuesRed" *ngIf="row.rowId === 'crossCheck'">
              {{ row.name }}
            </span>

            <ng-container *ngIf="row.rowId !== 'addrow' && row.rowId !== 'totalrow' && row.rowId !== 'crossCheck' ">

              <!-- Entire row edit case in workbook -->
              <ng-container *ngIf="isInsideWorkbook">
                <mat-form-field *ngIf="!((row.rowId === 'subtotal') && row.isDescHide)"
                  class="fixed-label label-none w-100" floatLabel="always" [ngClass]="{'fw-semibold': row.styles?.includes('bold'),
                'text-italic overflow-visible': row.styles?.includes('italic'),
                'text-decoration-underline': row.styles?.includes('underline'),
                'px-3': row.rowId.includes('_subrow') }">
                  <mat-label>Description</mat-label>
                  <input [id]="row.rowId+'NFS'" (keydown.Tab)="onTabChange($event,i)" matInput type="text"
                    placeholder="Description here" [(ngModel)]="row.name" (blur)="setDescription(row)" />
                </mat-form-field>
              </ng-container>

            </ng-container>
            }

          </td>
        </ng-container>

        <ng-container matColumnDef="search">
          <th mat-header-cell *matHeaderCellDef class="fs-col-search"></th>
          <td mat-cell *matCellDef="let row" class="fs-col-search"
            [ngClass]="{'disabled': activeFormatList.length ? true : false, 'd-none':row.rowId === 'textonly' }">
            @if(row.rowId === 'subheader' ||row.rowId === 'subtotal'){

            } @else{
            <ng-container *ngIf="row.rowId !== 'addrow' && row.rowId !== 'totalrow' && row.rowId !== 'crossCheck'">
              <!-- <mat-form-field class="fixed-label label-none w-100 icon-form-before">
                  <mat-label>Search</mat-label>
                  <input matInput type="text" class="color-grey" placeholder="Search" maxlength="50" [ngModel]="search"
                    [disabled]="isInsideWorkbook && row.name && row.name !== 'Description'  ? true : false"
                    [matMenuTriggerFor]="trialBalMenu" readonly />
                  <span matPrefix>
                <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                  </span>
                </mat-form-field> -->
              <button mat-button mat-stroked-button color="dark" class="button-medium text-start w-100"
                [disabled]="isInsideWorkbook && row.name && row.name !== 'Description'  ? true : false"
                [matMenuTriggerFor]="trialBalMenu">
                <span class="flexbox-row gap-8">
                  <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                  <span class="button-label">Search</span>
                </span>
              </button>
              <mat-menu #trialBalMenu="matMenu" class="trial-menu">
                <div class="flex-table fixed-header w-100" *ngIf="leadSheetData.length > 0"
                  style="max-height: 400px; overflow-y: auto;">
                  <div class="flex-table-header">
                    <p class="ft-cell ps-2 text-left current-date-cell">Acc No.</p>
                    <p class="ft-cell text-left des-cell">Description</p>
                    <p class="ft-cell pe-2 text-end prev-date-cell">Amount</p>
                  </div>
                  <button mat-menu-item class="ft-row button-row" *ngFor="let ls of leadSheetData"
                    (click)="(lsIdsInTable.includes(ls.trialBalanceId)) ? $event.stopPropagation() : setLeadSheetRow(ls, row)"
                    [ngClass]="{'disabled': (lsIdsInTable.includes(ls.trialBalanceId))}">
                    <p class="ft-cell text-left current-date-cell" title="{{ ls.accountCode }}">
                      <span class="text-ellipse">{{ ls.accountCode }}</span>
                    </p>
                    <p class="ft-cell ps-2 text-left des-cell" title="{{ ls.accountName }}">
                      <span class="text-ellipse">{{ ls.accountName }}</span>
                    </p>
                    <p class="ft-cell pe-2 text-end prev-date-cell" title="{{ getLSFinalAmt(ls.cost) }}">
                      <span class="text-ellipse">{{ getLSFinalAmt(ls.cost) }}</span>
                    </p>
                  </button>
                </div>
              </mat-menu>

              <div *ngIf="leadSheetData.length === 0">
                <ng-template #noDataFound>
                  <div class="no-data-found" style="min-height: 400px;">
                    <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                    <h6>No records found!</h6>
                  </div>
                </ng-template>
              </div>
            </ng-container>
            }

          </td>
        </ng-container>

        <ng-container [matColumnDef]="column.colId" *ngFor="let column of columnsData;let columnIndex = index">
          <th mat-header-cell *matHeaderCellDef class="fs-col-newadded text-end p-2" [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic overflow-visible': column?.styles?.includes('italic'),
            'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false }">
            <ng-container *ngIf=" editColumnId !== column?.colId ">
              <span class="flexbox-row gap-0 justify-content-end">
                <span class="flexbox-column gap-0">
                  <pre class="overflow-visible"
                    [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic'),
                  'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false }">{{ column.name }}</pre>
                  <ng-container *ngIf="column.extName">
                    <pre class="overflow-visible"
                      [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic'),
                  'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false }">{{ column.extName }}</pre>
                  </ng-container>
                  <ng-container *ngIf="column.formatValue">
                    <pre class="overflow-visible"
                      [ngClass]="{'fw-semibold': column?.styles?.includes('bold'), 'text-italic': column?.styles?.includes('italic') }">{{column.formatValue}}</pre>
                  </ng-container>
                </span>
                <button mat-button class="kebab-button hover-action-item" [matMenuTriggerFor]="colActions"
                  (menuOpened)="columnActionsMenu('OPEN')" (menuClosed)="columnActionsMenu('CLOSED')"
                  #addColumnMenu="matMenuTrigger">
                  <i class="fas fa-ellipsis-vertical"></i>
                </button>
                <mat-menu #colActions="matMenu" xPosition="before">
                  <ng-container *ngFor="let action of columnActions">
                    <button mat-menu-item class="add-row-btn"
                      *ngIf="(column.colId === 'cost' || column.colId === 'amortization') ? (action.key === 'format') : !(action.key === 'delete')"
                      [matMenuTriggerFor]="action.subMenu.length ? subMenu : null"
                      (click)="action.subMenu.length ? '' : this.executeColumnActions($event,column,action.key)">
                      <div class="flexbox-row gap-8 justify-content-between">
                        <span class="button-label">{{ action.value }}</span>
                      </div>
                    </button>
                    <mat-menu #subMenu="matMenu">
                      <ng-container *ngFor="let subItem of action.subMenu">
                        <button mat-menu-item class="add-row-btn" [disabled]="column.format === subItem.key"
                          (click)="applyColAction(column,action.key ,subItem)">
                          <div class="flexbox-row gap-8 justify-content-between">
                            <span class="button-label">{{ subItem.name }}</span>
                          </div>
                        </button>
                      </ng-container>
                    </mat-menu>
                  </ng-container>
                </mat-menu>
              </span>
            </ng-container>

          </th>
          <td mat-cell *matCellDef="let row;let rowIndex = index" class="fs-col-newadded text-end pe-2" [ngClass]="{'disabled': (activeFormatList.length ? !(activeFormatList.includes(column.colId)) : false),
          'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false ,
          'fw-semibold': column?.styles?.includes('bold'),
          'text-italic overflow-visible': column?.styles?.includes('italic') }">
            @if(row.rowId === 'subheader'){
            <span class="flexbox-row gap-0 justify-content-end">
              <span class="flexbox-column gap-0">
                <pre
                  [ngClass]="{'disabled': (activeFormatList.length ? !(activeFormatList.includes(column.colId)) : false),
                'bg-primary-lighter': activeFormatList.length ? (activeFormatList.includes(column.colId)) : false ,
                'fw-semibold': (column?.styles?.includes('bold') || row.values[columnIndex]?.styles?.includes('bold')),
                'text-italic overflow-visible': column?.styles?.includes('italic') }">{{ row.values[columnIndex]?.extName ? row.values[columnIndex].extName : row.name  }}</pre>
              </span>

              <button mat-button class="kebab-button hover-action-item" [matMenuTriggerFor]="subcolActions"
                (menuOpened)="columnActionsMenu('OPEN')" (menuClosed)="columnActionsMenu('CLOSED')"
                #addColumnMenu="matMenuTrigger">
                <i class="fas fa-ellipsis-vertical"></i>
              </button>
              <mat-menu #subcolActions="matMenu" xPosition="before">
                <ng-container *ngFor="let action of columnActions">
                  <button mat-menu-item class="add-row-btn" *ngIf="action.key === 'rename' || action.key === 'delete'"
                    (click)="this.subHeaderColActions($event,row,rowIndex, columnIndex ,action.key)">
                    <div class="flexbox-row gap-8 justify-content-between">
                      <span class="button-label">{{ action.value }}</span>
                    </div>
                  </button>
                </ng-container>
              </mat-menu>
            </span>

            } @else if(row.rowId === 'textonly'){

            } @else{

            <ng-container *ngIf="isInsideWorkbook">
              <ng-container *ngIf="row.rowId === 'subtotal';else generalRows ">
                <mat-form-field class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                'text-decoration-underline': row.styles?.includes('underline') }">
                  <input *ngIf="!(column.colId === 'total')" [id]="row.rowId+'NFS'+column.colId" matInput type="text"
                    class="cell-right full-row" [value]="showFormattedNumber(getColValue(row.values, column.colId))"
                    placeholder="0" disabled />
                  <input *ngIf="column.colId === 'total'" [id]="row.rowId+'NFS'+column.colId" matInput type="text"
                    class="cell-right full-row" [value]="showFormattedNumber(getRowTotalValue(row.values))"
                    placeholder="0" disabled />
                </mat-form-field>
              </ng-container>
              <ng-template #generalRows>
                <ng-container
                  *ngIf="row.rowId !=='addrow' && row.rowId !== 'totalrow' && row.rowId !== 'crossCheck' && column.colId !== 'total'">
                  <mat-form-field class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                    <input [id]="row.rowId+'NFS'+column.colId" matInput
                      [type]="row.trialBalanceId && ['currYear', 'priorYear'].includes(column.colId) ? 'text' : 'number'"
                      class="cell-right full-row" [value]="row.trialBalanceId && ['currYear', 'priorYear'].includes(column.colId) ? (showFormattedNumber(getColValue(row.values, column.colId)) == 0 ? '' : showFormattedNumber(getColValue(row.values, column.colId)))  :
                       (getColValue(row.values, column.colId) == 0 ? '' : getColValue(row.values, column.colId))"
                      placeholder="0" onKeyPress="if(this.value.length == 14) return false;"
                      (keydown.Tab)="onTabChange($event,rowIndex,columnIndex)"
                      (blur)="setColvalue(row.values, column.colId,row.rowId+'NFS'+column.colId)"
                      [disabled]="row.trialBalanceId && ['currYear', 'priorYear'].includes(column.colId)" />
                  </mat-form-field>
                  <!-- <div *ngIf="editRowId !== row.rowId">
                    {{ showFormattedNumber(getColValue(row.values, column.colId)) }}
                  </div> -->
                </ng-container>
                <mat-form-field [title]="showFormattedNumber(getRowTotalValue(row.values))"
                  *ngIf="row.rowId !=='addrow' && row.rowId !== 'totalrow' && column.colId === 'total' && row.rowId !== 'crossCheck'"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row" placeholder="0"
                    [value]="showFormattedNumber(getRowTotalValue(row.values))" disabled />
                </mat-form-field>


                <span *ngIf="row.rowId ==='addrow'"></span>
                <mat-form-field [title]="showFormattedNumber(getTotalColValue(column.colId))"
                  *ngIf="row.rowId === 'totalrow' && column.colId !== 'total'"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row" placeholder="0"
                    [value]="showFormattedNumber(getTotalColValue(column.colId))" disabled />
                </mat-form-field>

                <mat-form-field [title]="showFormattedNumber(getGrandTotalValue())"
                  *ngIf="row.rowId === 'totalrow' && column.colId === 'total'"
                  class="fixed-label label-none flex-1 edit-mode" [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row" placeholder="0"
                    [value]=" showFormattedNumber(getGrandTotalValue())" disabled />
                </mat-form-field>
                <span *ngIf="row.rowId ==='crossCheck' && !['currYear','priorYear'].includes(column.colId)"></span>
                <mat-form-field [title]="showFormattedNumber(getCrossCheckVal('currYear'))"
                  *ngIf="row.rowId ==='crossCheck' && column.colId === 'currYear'"
                  class="fixed-label label-none flex-1 edit-mode " [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row misMatchValuesRed" placeholder="0"
                    [value]=" showFormattedNumber(getCrossCheckVal('currYear'))" disabled />
                </mat-form-field>
                <mat-form-field [title]="showFormattedNumber(getCrossCheckVal('priorYear'))"
                  *ngIf="row.rowId ==='crossCheck' && column.colId === 'priorYear'"
                  class="fixed-label label-none flex-1 edit-mode " [ngClass]="{'fw-semibold': (column?.styles?.includes('bold') || row.styles?.includes('bold')),
                  'text-italic overflow-visible': (column?.styles?.includes('italic') || row.styles?.includes('italic')),
                  'text-decoration-underline': row.styles?.includes('underline') }">
                  <input matInput type="text" class="cell-right full-row misMatchValuesRed" placeholder="0"
                    [value]=" showFormattedNumber(getCrossCheckVal('priorYear'))" disabled />
                </mat-form-field>
              </ng-template>

            </ng-container>
            }


          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"
          [ngClass]="{'bg-primary-lighter': activeFormatList.includes('header'),'disabled': activeFormatList.length ? true : false }">
        </tr>
        <tr mat-row *matRowDef="let row;let rowIndex=index; columns: displayedColumns" cdkDrag [cdkDragData]="row"
          [class.hidden]="isNoDifference(row)"
          [cdkDragDisabled]="(row.rowId === 'totalrow' || row.rowId === 'addrow' || row.rowId === 'subheader' || row.rowId === 'crossCheck')"
          (click)="editRow(row)" [ngClass]="{
        'subHeaderBgCss': ((row.rowId === 'subheader') && !(rowIndex === activeRowIndex)),
        'bg-primary-lighter': rowIndex === activeRowIndex,
        'text-italic overflow-visible': row.styles?.includes('italic'),
        'text-decoration-underline': row.styles?.includes('underline')
      }">
        </tr>

      </table>
    </div>
  </div>
</div>

<!-- delete column/row popup-->
<ng-template #deleteConfirmDialog let-data>
  <div class="countable-dialog confirmation-dailog deleteConfirmDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title">Delete {{data.toDelete}}</h4>
      <button color="error" class="close" [mat-dialog-close]="close">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <!-- <p [innerHtml]="data.text"></p> (click)="cancelDelete()" (click)="data.toDelete === 'Row' ? deleteRow() : deleteColumn()"-->
      <p class="fw-medium" [innerHtml]="data.subHeader"></p>
      <p class="text-gray-6" [innerHtml]="data.text"></p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-medium" color="dark"
        [mat-dialog-close]="false">{{data.cancelText}}</button>
      <button mat-button mat-flat-button class="button-medium" color="error"
        [mat-dialog-close]="true">{{data.doneText}}</button>
    </div>
  </div>
</ng-template>

<!-- format changes apply to selected table or note -->
<ng-template #applyFormatDialog let-data>
  <div class="countable-dialog confirmation-dailog applyFormatDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title">Month & Year Format</h4>
      <button color="error" class="close" [mat-dialog-close]="'close'">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>Format changes for the current and prior years to be applied to all notes or only to the selected note?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close]="'one'">Apply To
        Note</button>
      <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]="'all'">Apply To
        All</button>
    </div>
  </div>
</ng-template>

<ng-template #formatColDialog>
  <div class="countable-dialog confirmation-dailog applyFormatDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">Format Column</h4>
      <button color="error" class="close" [mat-dialog-close]="notes?.NONE_FORMAT">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>Format changes for the manual column to be applied to all columns, or only to the selected column?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-medium" color="dark"
        [mat-dialog-close]="notes?.SINGLE_FORMAT">Apply To
        Column
      </button>
      <button mat-button mat-flat-button class="button-medium" color="primary"
        [mat-dialog-close]="notes?.ALL_FORMAT">Apply To
        All
      </button>
    </div>
  </div>
</ng-template>
